/* MEE BARSA — Product page interactions.
   Thumbnail swap, click-only menu drawer, scroll reveal.
   Idempotent + re-inits in the Shopify theme editor. */
(function () {
  function initProduct(root) {
    root = root || document;
    var scope = root.matches && root.matches('.mbpd') ? root : root.querySelector && root.querySelector('.mbpd');
    if (!scope || scope.dataset.mbProductBound === 'true') return;
    scope.dataset.mbProductBound = 'true';

    // Thumbnail -> main image swap
    var mainImg = scope.querySelector('#mbpdMainImg');
    if (mainImg && !mainImg.dataset.zoomBound) {
      mainImg.dataset.zoomBound = 'true';
      var opener = mainImg.closest('.main-frame');
      opener.tabIndex = 0;
      opener.setAttribute('role', 'button');
      opener.setAttribute('aria-label', 'Open product image zoom');
      var viewer = document.createElement('dialog');
      viewer.className = 'mb-image-viewer';
      viewer.setAttribute('aria-label', 'Product image zoom');
      viewer.innerHTML = '<div class="mb-zoom-controls"><button type="button" data-zoom-out aria-label="Zoom out">−</button><button type="button" data-zoom-in aria-label="Zoom in">+</button><button type="button" data-zoom-close aria-label="Close image zoom">Close</button></div><div class="mb-zoom-canvas"><img alt=""></div>';
      document.body.appendChild(viewer);
      var large = viewer.querySelector('img'), zoom = 1, oldOverflow = '';
      function renderZoom() {
        large.style.width = (zoom * 100) + '%';
        large.style.height = (zoom * 100) + '%';
        viewer.querySelector('[data-zoom-out]').disabled = zoom <= 1;
        viewer.querySelector('[data-zoom-in]').disabled = zoom >= 3;
      }
      function openZoom() {
        if (viewer.open) return;
        large.src = mainImg.currentSrc || mainImg.src;
        large.alt = mainImg.alt;
        zoom = 1;
        renderZoom();
        oldOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        viewer.showModal();
        viewer.querySelector('.mb-zoom-canvas').scrollTo(0, 0);
      }
      opener.addEventListener('click', openZoom);
      opener.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openZoom(); }
      });
      viewer.querySelector('[data-zoom-in]').onclick = function () { zoom = Math.min(3, zoom + .5); renderZoom(); };
      viewer.querySelector('[data-zoom-out]').onclick = function () { zoom = Math.max(1, zoom - .5); renderZoom(); };
      viewer.querySelector('[data-zoom-close]').onclick = function () { viewer.close(); };
      viewer.addEventListener('close', function () { document.body.style.overflow = oldOverflow; opener.focus(); });
    }
    var thumbs = scope.querySelectorAll('#mbpdThumbs button');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('active');
        b.setAttribute('aria-pressed', 'true');
        if (mainImg && b.dataset.src) { mainImg.src = b.dataset.src; }
      });
    });

    // Menu drawer — click only, never hover
    var drawer = scope.querySelector('#mbpdDrawer');
    var scrim = scope.querySelector('#mbpdScrim');
    var menuBtn = scope.querySelector('#mbpdMenuBtn');
    var closeBtn = scope.querySelector('#mbpdDrawerClose');
    var lastFocus = null;
    function openD() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.classList.add('show');
      document.body.style.overflow = 'hidden';
      window.setTimeout(function () { drawer.focus(); }, 50);
    }
    function closeD() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.classList.remove('show');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (menuBtn) menuBtn.onclick = openD;
    if (closeBtn) closeBtn.onclick = closeD;
    if (scrim) scrim.onclick = closeD;
    function onDrawerKeydown(e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeD();
      if (e.key === 'Tab' && drawer && drawer.classList.contains('open')) {
        var focusable = drawer.querySelectorAll('a[href],button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    document.addEventListener('keydown', onDrawerKeydown);

    // Scroll reveal
    var reveals = scope.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }
    scope.mbProductCleanup = function () {
      document.removeEventListener('keydown', onDrawerKeydown);
      if (io) io.disconnect();
      if (viewer) {
        if (viewer.open) {
          viewer.close();
          document.body.style.overflow = oldOverflow;
        }
        viewer.remove();
      }
    };
  }

  if (document.readyState !== 'loading') { initProduct(); }
  else { document.addEventListener('DOMContentLoaded', function () { initProduct(); }); }

  // Theme editor re-init
  document.addEventListener('shopify:section:load', function (e) { initProduct(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var scope = e.target.matches('.mbpd') ? e.target : e.target.querySelector('.mbpd');
    if (scope && scope.mbProductCleanup) scope.mbProductCleanup();
  });
})();
